import { h } from 'preact'
import ButtonControl from '../button-control'

type Props = {
  img_src: string,
  header: string,
  text: string,
  button?: {
    link: string,
    text: string
  },
  children?: JSX.Element
}

const EmptyPage = ({
  img_src,
  header,
  text,
  button,
  children
} : Props) => (
  <div className='control_empty'>
    <img className='control_empty_image' src={img_src} />
    <p className='control_empty_message_header'>{header}</p>
    <p>{text}</p>
    {button && <a href={button.link} className='control_empty--btn'>
      <ButtonControl newStyle size='medium' title={button.text} variant='brand' />
    </a>}
    { children && children }
  </div>
)

export default EmptyPage
